import React from 'react';
import TopIconGuest from 'components/topIconGuest/index';

const HeaderRowGuest = () => {
  return (
    <div className="header_row--hamburger_menu flex h-fit items-center justify-between px-4 pb-1 pt-4 lg:min-h-[96px] lg:items-center lg:px-6 lg:py-5">
      <TopIconGuest className="lg:self-start" />
    </div>
  );
};

export default HeaderRowGuest;
